// extracted by mini-css-extract-plugin
export default {"root":"denserPeriod_root__Fn0gc","back":"denserPeriod_back__S+9ws","form":"denserPeriod_form__0qdwq"};